module.exports = __webpack_public_path__ + "img/kalon.81edb6f2.png";